import { render, staticRenderFns } from "./PrizeLotDate.vue?vue&type=template&id=47cac781&"
import script from "./PrizeLotDate.vue?vue&type=script&lang=js&"
export * from "./PrizeLotDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports